import { render, staticRenderFns } from "./ShapesPallette.vue?vue&type=template&id=cbfb9e9a&scoped=true"
import script from "./ShapesPallette.vue?vue&type=script&lang=js"
export * from "./ShapesPallette.vue?vue&type=script&lang=js"
import style0 from "./ShapesPallette.vue?vue&type=style&index=0&id=cbfb9e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfb9e9a",
  null
  
)

export default component.exports